/**
 * This class takes care of reading config options from the window variable
 * window.usercentrics.config = {...}
 */
export class ConfigService {

    static CONFIG_IMPLICIT_CONSENTS = 'deactivateImplicit';
    static CONFIG_INTERACTION_EVENTS = 'activateInteractionEvents';

    /**
     * Wrapper function that returns true if implicit consents where deactivated through
     * window.usercentrics.config = {deactivateImplicit: 'yes'}, false otherwise.
     */
    public static areImplicitConsentsDeactivated(): boolean {
        const value: string = String(ConfigService.getConfig(ConfigService.CONFIG_IMPLICIT_CONSENTS));
        if (value.toLowerCase() === 'yes') {
            return true;
        }
        return false;
    }

    /**
     * Wrapper function that returns true if ui interaction events are activated through
     * window.usercentrics.config = {activateInteractionEvents: 'yes'}, false otherwise.
     */
    public static areInteractionEventsActivated(): boolean {
        const value: string = String(ConfigService.getConfig(ConfigService.CONFIG_INTERACTION_EVENTS));
        if (value.toLowerCase() === 'yes') {
            return true;
        }
        return false;
    }

    /**
     * Generic function that reads the value of given key from the config object. If either the object
     * or the key are not existing, null is returned.
     * @param key 
     */
    public static getConfig(key: string) {
        if (typeof window.usercentrics === 'undefined' || typeof window.usercentrics.config === 'undefined') {
            return null;
        }

        const config = window.usercentrics.config;
        if (typeof config[key] === 'undefined') {
            return null;
        }
        return config[key];
    }
}